import { BusinessCategory } from 'constants/synergy';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';
import type { MenuActions } from 'ts/types/config.types';
import { noop } from 'utils/global-utils';
import modalActions from 'redux/actions/modalActions';
import { MotorContactUs } from 'containers/Modals';

const motorContactUs = (dispatch: Dispatch<any>) => {
  return dispatch(
    modalActions.showModalV2({
      content: MotorContactUs,
      showCloseIcon: false,
    }),
  );
};

export const useMenuActions = (): Record<string, MenuActions> => {
  const dispatch = useDispatch();

  return {
    [BusinessCategory.MOTOR]: {
      CONTACT: () => motorContactUs(dispatch),
      noop,
    },
    [BusinessCategory.HOME]: {
      noop,
    },
  };
};
